"use client";
import { jsx as h } from "react/jsx-runtime";
import { cva as b } from "class-variance-authority";
import { forwardRef as w, useState as x, useRef as v, useEffect as y } from "react";
import { cn as r } from "./index23.mjs";
import { getAccessibleFocusStyles as E } from "./index24.mjs";
const R = b(
  `
    block
    w-full
    rounded-md
    transition-colors
    placeholder:transition-colors
    disabled:cursor-not-allowed
    disabled:opacity-60
    `,
  {
    variants: {
      tone: {
        dark: "bg-gray-925 text-white placeholder:text-gray-400 border-gray-700",
        light: "bg-white text-gray-900 placeholder:text-gray-500 border-gray-300"
      },
      size: {
        sm: "text-sm leading-5 px-3 py-2 h-10",
        md: "text-base leading-6 px-4 py-3 h-12",
        lg: "text-base leading-6 px-4 py-4 h-14"
      }
    },
    defaultVariants: {
      tone: "light",
      size: "md"
    }
  }
), L = w(
  ({ className: i, size: a = "md", tone: l = "light", keyboardFocusOnly: e = !1, ...u }, c) => {
    const [d, o] = x(!1), t = v("mouse");
    y(() => {
      if (!e) return;
      const n = () => {
        t.current = "mouse";
      }, s = (p) => {
        p.key === "Tab" && (t.current = "keyboard");
      };
      return document.addEventListener("mousedown", n), document.addEventListener("keydown", s), () => {
        document.removeEventListener("mousedown", n), document.removeEventListener("keydown", s);
      };
    }, [e]);
    const f = () => {
      e && t.current === "keyboard" && o(!0);
    }, m = () => {
      e && o(!1);
    }, g = e ? r(
      "focus:outline-none focus:ring-0 focus:border-none",
      "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-none",
      d && "!outline-solid !outline-2 !outline-offset-2 !outline-white !ring-2 !ring-blue-600"
    ) : E();
    return /* @__PURE__ */ h(
      "input",
      {
        ref: c,
        className: r(R({ size: a, tone: l }), g, i),
        onFocus: f,
        onBlur: m,
        ...u
      }
    );
  }
);
L.displayName = "Input";
export {
  L as Input
};
